export const reviewActionTypes = {
  REVIEW_FROM_SERVER: 'REVIEW_FROM_SERVER',
};
